import { IInstrumentosEjecucion } from "../interfaces/InstrumentosEjecucion";
import { get, post } from "./fetch";

export const getInstrumentExecutionData = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Info_Instrumentos OP:1 parametro o 2 sin
  var result = await get(`/api/instrumentos-ejecucion/${code}`);
  return result;
};

export const getExecutionDataGlobal = async ():Promise<IInstrumentosEjecucion> => {
  var result = await get(`/api/instrumentos-ejecucion/global`);
  return result;
}